<template>
  <div v-clickOutside="close" class="md:relative">
    <div class="flex" @click="toggleShow">
      <slot>
        <i
          class="icon-calendar cursor-pointer p-8 text-22"
          :class="classes"
        />
      </slot>
    </div>

    <div v-if="show" class="absolute z-100" :class="position">
      <v-calendar
        :key="currentDate"
        :is-dark="isDarkMode"
        :attributes="computedAttributes"
        trim-weeks
        class="font-Inter"
        :from-date="date"
        @dayclick="dayclick"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    currentDate: [Date, String],
    attributes: Array,
    position: {
      type: String,
      default: 'top-37 right-0 '
    }
  },

  emits: ['dayclick'],

  setup (props, { emit }) {
    const { state, getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)

    const events = computed(() => state.planner.allEvents)

    const show = ref(false)

    const date = computed(() => new Date(props.currentDate))

    const classes = computed(() => {
      const prefix = show.value ? '' : 'hover:'
      return `${isDarkMode.value ? `${prefix}bg-dark-500 text-app-color` : `${prefix}bg-menu-hover text-dark-600`} rounded-6 anim-color-200`
    })

    const computedAttributes = computed(() => {
      if (props.attributes) return props.attributes

      const mappedEvents = events.value.map(event => {
        return {
          dates: event.showAt,
          dot: {
            class: 'bg-link-color',
            style: {
              backgroundColor: ''
            }
          },
          popover: {
            label: event.event.title
          },
          customData: event
        }
      })

      return [
        ...mappedEvents,
        {
          key: 'today',
          highlight: {
            contentClass: 'text-link-color anim-color',
            contentStyle: { fontWeight: 700 }
          },
          dates: new Date()
        }
      ]
    })

    function toggleShow () {
      show.value = !show.value
    }

    function close () {
      show.value = false
    }

    function dayclick (data) {
      emit('dayclick', data)
      close()
    }

    return {
      // ref
      // data
      show,
      date,
      // computed
      classes,
      computedAttributes,
      isDarkMode,
      // function
      toggleShow,
      close,
      dayclick
    }
  }
})
</script>

<style lang="scss">
.vc-day-content {
  border-radius: 6px;

  &:hover {
    @apply bg-menu-hover
  }
}
.vc-weekday {
  color: #ccc
}

.vc-title {
  font-weight: 700;
  color: #323232;
}

.vc-svg-icon {
  @apply text-grey-300;

  &:hover {
    @apply text-dark-600
  }
}

.vc-arrow:hover {
  @apply bg-menu-hover
}
</style>
